import { CSSProperties, StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../web/components-v2/Theme/theme';
import { eventTintColor, navigation, titles } from '../../../../../web/styles/colors';
import { CssSelectors, absoluteCenterStyle, baseStyles } from '../../../../../web/styles/styles';
const { colors, common, spacing } = THEME;

export const styleSheet = StyleSheet.create({
	actionEntities: {
		alignItems: 'center',
		color: colors.primary.main,
		cursor: 'pointer',
		display: 'inline-flex',
		fontSize: 14,
		marginLeft: 30,
	},
	addCustomCard: {
		color: colors.hover.main,
	},
	addLogoButtonLabel: {
		height: 50,
	},
	buttonsWrapper: {
		display: 'flex',
	},
	column: {
		marginBottom: 15,
		marginTop: spacing.xs,
		width: '50%',
	},
	columnButtonIcon: {
		minWidth: 16,
	},
	companyLogoButtonWrap: {
		':hover': {
			...CssSelectors.allChildren(
				{
					display: 'block',
				},
				'img'
			),
			...CssSelectors.allChildren(
				{
					display: 'block',
				},
				'.remove-logo-button'
			),
		},
		...CssSelectors.allChildren(
			{
				display: 'none',
			},
			'img'
		),
		...CssSelectors.allChildren(
			{
				display: 'none',
			},
			'.remove-logo-button'
		),
		display: 'flex',
		height: 50,
		minWidth: 400,
		position: 'relative',
	},
	container: {
		display: 'flex',
		justifyContent: 'flex-start',
		marginTop: 20,
		minHeight: 400,
		width: '100%',
	},
	customTextColor: {
		color: 'rgb(4, 108, 182)',
	},
	customEditButton: {
		left: 0,
		position: 'absolute',
	},
	customFieldsList: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	customLabelWrap: {
		display: 'inline-flex',
		paddingLeft: 30,
		position: 'relative',
	},
	customRow: {
		...(baseStyles.brandLink as CSSProperties),
		fontSize: 13,
	},
	deleteKeyFactsHeader: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		margin: '0 20px',
	},
	deleteRenewKeyFactsModal: {
		maxWidth: 400,
	},
	disable: {
		opacity: 0.6,
	},
	dropdown: {
		minWidth: 130,
	},
	expandable: {
		overflow: 'hidden',
		position: 'relative',
	},
	exportButton: {
		...(baseStyles.brandLink as CSSProperties),
		fontSize: 13,
	},
	hawksoftInfo: {
		color: navigation,
		fontSize: 13,
		marginTop: 6,
	},
	header: {
		borderBottom: 'solid 1px rgb(211, 219, 222)',
		color: navigation,
		fontSize: 13,
		paddingBottom: 15,
		paddingLeft: 15,
		paddingTop: 15,
	},
	infoFieldContainerBottom: {
		alignItems: 'center',
		borderBottom: 'solid 1px rgb(211, 219, 222)',
		display: 'flex',
		height: 55,
		justifyContent: 'space-between',
		marginBottom: 0,
		paddingLeft: 15,
		paddingRight: 10,
	},
	infoFieldContainerFullContainer: {
		borderLeft: 'solid 1px rgb(211, 219, 222)',
		borderRight: 'solid 1px rgb(211, 219, 222)',
	},
	infoFieldContainerLeft: {
		borderRight: 'solid 1px rgb(211, 219, 222)',
		paddingRight: 15,
	},
	infoFieldValueBottom: {
		alignItems: 'center',
		color: titles,
		display: 'flex',
		fontSize: 13,
		position: 'relative',
	},
	infoFieldBottomNewIcon: {
		position: 'absolute',
		top: 0,
		left: 0,
		backgroundColor: eventTintColor,
		borderRadius: common.borderRadius,
		fontSize: 11,
		color: titles,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '2px 4px',
		gap: spacing.xs,

		...CssSelectors.allChildren(
			{
				width: 10,
				height: 10,
			},
			'svg'
		),
	},
	loading: {
		...absoluteCenterStyle,
	},
	logoImage: {
		height: 50,
		left: 300,
		position: 'absolute',
		top: '50%',
		transform: 'translateY(-50%)',
	},
	multiSelectPlaceholder: {
		color: '#999',
		fontSize: 13,
	},
	multiText: {
		marginRight: 10,
	},
	numericInput: {
		width: 110,
	},
	overviewContainer: {
		':last-child': {
			justifyContent: 'flex-end',
		},
		border: '1px solid #D3DBDE',
		borderRadius: 10,
		boxShadow: '0px 0px 6px rgba(139, 139, 139, 0.1)',
		boxSizing: 'border-box',
		display: 'flex',
		flexWrap: 'wrap',
		marginLeft: 20,
		marginRight: 20,
		marginTop: 14,
		padding: '0px 30px',
	},
	resetAccount: {
		...(baseStyles.brandLink as CSSProperties),
		color: colors.danger.main,
		fontSize: 13,
	},
	settingsSearch: {
		marginRight: 10,
		minWidth: 400,
	},
	settingsSearchContainer: {
		display: 'flex',
	},
	subRow: {
		paddingLeft: 30,
	},
	// Puts the control on its own full-width line under the label (rows whose input needs more room).
	stackedRow: {
		alignItems: 'stretch',
		flexDirection: 'column',
		gap: spacing.sm,
		height: 'auto',
		justifyContent: 'center',
		paddingBottom: spacing.md,
		paddingTop: spacing.md,
	},
	emailInput: {
		width: 360,
	},
	savingText: {
		color: navigation,
		fontSize: 12,
		marginLeft: spacing.sm,
	},
	donationTagModal: {
		minWidth: 400,
		padding: 20,
	},
	donationTagModalTitle: {
		fontSize: 18,
		fontWeight: 600,
		marginBottom: 20,
	},
	donationTagModalRow: {
		alignItems: 'center',
		borderBottom: `1px solid ${colors.border.light}`,
		display: 'flex',
		justifyContent: 'space-between',
		padding: '12px 0',
	},
	donationTagModalLabel: {
		alignItems: 'center',
		display: 'flex',
		gap: 6,
	},
	donationTagModalInfoIcon: {
		cursor: 'pointer',
		display: 'inline-flex',
	},
	donationTagModalHoverContent: {
		fontSize: 12,
	},
	donationTagModalFooter: {
		display: 'flex',
		gap: 10,
		justifyContent: 'flex-end',
		marginTop: 20,
	},
	donationTagWarning: {
		color: colors.danger.main,
		fontSize: 13,
		margin: '4px 0 0',
	},
	donationTagInfo: {
		color: colors.text.light,
		fontSize: 13,
		marginTop: 12,
	},
});
